import { css, useTheme } from '@emotion/react';
import { forwardRef } from 'react';

import { glass, radii, shadows, spacing } from '@/theme/tokens';

export type CardVariant = 'standard' | 'compact' | 'elevated' | 'glass';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: string;
}

const variantRadius = {
  standard: radii.lg,
  compact: radii.md,
  elevated: radii.lg,
  glass: radii.lg,
} as const;

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'standard', padding = spacing.lg, className, ...props },
  ref,
) {
  const theme = useTheme();

  const variantStyles = {
    standard: css`
      background: ${theme.colors.surface};
      border: 1px solid ${theme.colors.border};
    `,
    compact: css`
      background: ${theme.colors.surface};
      border: 1px solid ${theme.colors.border};
    `,
    elevated: css`
      background: ${theme.colors.surfaceElevated};
      box-shadow: ${shadows.elevated};
    `,
    glass: css`
      background: ${glass.bg};
      backdrop-filter: ${glass.backdrop};
      border: 1px solid rgba(255, 255, 255, 0.1);
    `,
  };

  return (
    <div
      ref={ref}
      className={className}
      css={[
        css`
          border-radius: ${variantRadius[variant]};
          padding: ${padding};
        `,
        variantStyles[variant],
      ]}
      {...props}
    />
  );
});
